import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About Jonna", testId: "nav-about" },
  { to: "/services", label: "Services", testId: "nav-services" },
  { to: "/approach", label: "Our Approach", testId: "nav-approach" },
  { to: "/success-stories", label: "Success Stories", testId: "nav-success" },
  { to: "/faq", label: "FAQ", testId: "nav-faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-cream/80 backdrop-blur-md border-b border-ink/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="navbar-brand-link">
            <Logo size={36} />
          </Link>
          <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={item.testId}
                className={({ isActive }) =>
                  `text-sm font-medium link-underline transition-colors ${
                    isActive ? "text-terracotta" : "text-ink/80 hover:text-ink"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <Link to="/contact" data-testid="nav-cta-waitlist">
              <Button className="rounded-full bg-terracotta hover:bg-terracotta-600 text-white px-5 h-11 font-medium shadow-sm hover:-translate-y-0.5 transition-all">
                Join the Waitlist
              </Button>
            </Link>
          </div>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 -mr-2 text-ink"
            aria-label="Toggle menu"
            data-testid="navbar-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {open && (
          <div className="lg:hidden pb-6 animate-fade-up" data-testid="navbar-mobile-menu">
            <div className="flex flex-col gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  data-testid={`${item.testId}-mobile`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-2.5 rounded-lg text-base ${
                      isActive ? "bg-terracotta-100 text-terracotta" : "text-ink hover:bg-ink/5"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                className="mt-3"
                data-testid="nav-cta-waitlist-mobile"
              >
                <Button className="w-full rounded-full bg-terracotta hover:bg-terracotta-600 text-white h-11">
                  Join the Waitlist
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
